var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 94,
    viewBox: "0 0 102 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5748 44.7091L4.88404 51.3999",
    stroke: "#818CF8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88635 44.7113L11.5771 51.4021",
    stroke: "#818CF8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6693 2L80.5618 8.10747",
    stroke: "#818CF8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5601 2.00195L86.6675 8.10943",
    stroke: "#818CF8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.7767,
    cy: 87,
    r: 3,
    stroke: "#818CF8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42.1158C57.3833 42.1158 62.5579 36.9412 62.5579 30.5579C62.5579 24.1746 57.3833 19 51 19C44.6168 19 39.4421 24.1746 39.4421 30.5579C39.4421 36.9412 44.6168 42.1158 51 42.1158Z",
    fill: "#E5E7EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1158 63.2288C74.1158 70.4092 74.1158 76.2315 51 76.2315C27.8842 76.2315 27.8842 70.4092 27.8842 63.2288C27.8842 56.0485 38.2343 50.2262 51 50.2262C63.7657 50.2262 74.1158 56.0485 74.1158 63.2288Z",
    fill: "#E5E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.aa2013ae8a573f3e0398f7db602468ed.svg";
export { ForwardRef as ReactComponent };